import { Dialog, DialogActions, Typography } from "@mui/material";

const SequenceDeleteModal = ({
  showSequenceCartDeleteModal,
  setShowSequenceCartDeleteModal,
  sequenceDeleteItem,
  setSequenceDeletedItem,
  handleSequenceCartDelete,
}) => {
  return (
    <Dialog
      open={showSequenceCartDeleteModal}
      onClose={() => setShowSequenceCartDeleteModal(false)}
    >
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Delete Cart Items
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Are you sure you want to delete{" "}
          <strong>{sequenceDeleteItem?.type}</strong> details ?
        </Typography>
      </div>
      <DialogActions>
        <button
          className="create-btn"
          style={{ width: "120px" }}
          onClick={handleSequenceCartDelete}
        >
          Yes
        </button>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => {
            setShowSequenceCartDeleteModal(false);
            setSequenceDeletedItem(null);
          }}
        >
          No
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default SequenceDeleteModal;
